import { Box, Grid } from '@mui/material';
import { parseMedicalInformationStatus } from '../func/parse';
import {
  MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_DOCUMENT_REFERENCE_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_IMAGE_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_VIDEO_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME
} from '../constants/constants';
import { useMedicalHealthInformationContext } from '../Context';
import Card from './Card';

// カードの横幅
const listCardWidth = 353;

const MedicalHealthInformationBranch = () => {
  const { setActiveStep, activeMedicalHealthInformation } = useMedicalHealthInformationContext();

  return (
    <Box sx={{ marginTop: '16px' }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container spacing={2} sx={{ paddingX: '20px', maxWidth: `calc(${listCardWidth}px *2 + 20px)` }}>
            <Card
              onClick={() => setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME)}
              label={'問診'}
              status={parseMedicalInformationStatus(activeMedicalHealthInformation)}
            />
            {!!activeMedicalHealthInformation.observation_list.length && (
              <Card onClick={() => setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME)} label={'検査'} />
            )}
            {!!activeMedicalHealthInformation.condition_list.length && (
              <Card onClick={() => setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME)} label={'診断'} />
            )}
            {!!activeMedicalHealthInformation.document_reference_list.length && (
              <Card
                onClick={() => setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_DOCUMENT_REFERENCE_NAME)}
                label={'書類'}
              />
            )}
            {!!activeMedicalHealthInformation.media_image_list.length && (
              <Card onClick={() => setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_IMAGE_NAME)} label={'画像'} />
            )}
            {!!activeMedicalHealthInformation.media_video_list.length && (
              <Card onClick={() => setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_VIDEO_NAME)} label={'動画'} />
            )}
          </Grid>
        </Grid>
        <Grid item xs={0} md={3} sm={2} />
      </Grid>
    </Box>
  );
};
export default MedicalHealthInformationBranch;
